import SortBtn from "./SortBtn";

export type SortType = 'ASC' | 'DESC' | null;

export default SortBtn;
